import { ApproveRejectDialogComponent } from './../approve-reject-dialog/approve-reject-dialog.component';
import { LicenseDataService } from '../../services/agentLicense/license-data.service'
import { LicenseDialogueComponent } from '../license-dialogue/license-dialogue.component';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { InsuranceDocsClearDialogComponent } from '../insurance-docs-clear-dialog/insurance-docs-clear-dialog.component';
import { SearchTermservice } from '../../services/search/search-service.service'
import { InsuranceDoc } from '../../model/insurance.model'
import { forEach } from '@angular/router/src/utils/collection';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule, MatCheckboxModule, MatPaginatorIntl } from '@angular/material';
import { Sort } from '@angular/material';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { MatIconModule } from '@angular/material';
import { SortPipe } from '../../../shared/sortPipe';
import { PageEvent } from '@angular/material';
import { ViewChild } from '@angular/core';
import { MatFormFieldModule } from '@angular/material';
import { MatInputModule } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DownloadService } from '../../services/download/download.service';
import { InsuranceService } from '../../services/insurance/insurance.service';
import { Subject } from 'rxjs/Subject';
import * as moment from 'moment';
import { PendingApprovalDialogComponent } from '../pending-approval-dialog/pending-approval-dialog.component';
import { DisableRow } from '../../../shared/globalService';
import { GetDocStatusColor } from '../../../shared/globalService';

@Component({
  selector: 'app-agent-license',
  templateUrl: './agent-license.component.html',
  styleUrls: ['./agent-license.component.css']
})
export class AgentLicenseComponent implements OnInit {
  public documentsAllowedToUpload = [];
  refresh = new Subject();
  doctype;
  agentName: string;
  MasterVendorId;
  agentDetails;
  pageSize = 10;
  insurancedocs = [];
  agentdoctype = [];
  dataSource: MatTableDataSource<UserData>;
  displayedColumns = ['DocumentTypeName', 'FileName', 'ExpirationDate', 'UploadedTimeStamp', 'DocumentStatus', 'FileEdit'];
  message: string;
  sortedData;
  clientDisable: any;
  clientHidden: any;
  public role: string;
  public Data;

  data: boolean = true;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  length: number;
  ispaginationFlag: boolean;
  noResults: string;
  licenseData: Array<any> = [];
  docCategory: any;
  errorMessage: String = '';
  errorEnable: boolean = false;
  uploadedFileName;
  vendorName;
  placeholder = "Select a Document";
  docStatus: boolean = false;
  grey: boolean = false;
  approve_reject_button: boolean = false;
  disable_edit : boolean = false;

  constructor(public insuranceservice: InsuranceService,
              private downloadservice: DownloadService,
              private http: Http,
              private searchTermservice: SearchTermservice,
              private router: Router,
              public dialog: MatDialog,
              private licenseservice: LicenseDataService,
              private disabletheRow: DisableRow,
              private getDocStatusColor: GetDocStatusColor) {
      this.licenseservice.licensedoctypeget().subscribe(res => {
      this.agentdoctype = res.DocumentTypes;
      this.docCategory = this.agentdoctype[0].Category;
      this.populateDocumentTypeDropDown();
    }, error => {
      this.errorMessage = "License document types: " + error;
      this.errorEnable = true;
    });
  }

  pageEvent: PageEvent;

  ngOnInit() {
    this.uploadedFileName = 'Vendor License - ' + this.vendorName;
    this.licenseservice.load.subscribe(res => {
      if (res === 'success') {
        this.doctype = null;
        this.getDetails();
      }
    });
    this.getDetails();

    this.MasterVendorId = localStorage.getItem("AgentId");
    this.vendorName = localStorage.getItem('AgentName');
    this.searchTermservice.detailsOfAgent(this.MasterVendorId).subscribe(res => {
      this.agentDetails = res;
      localStorage.setItem('AgentName', this.agentDetails.name);
    }, error => {
      this.errorMessage = "Vendor details: " + error;
      this.errorEnable = true;
    });

    this.role = localStorage.getItem("Role")
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
    }
  }

  populateDocumentTypeDropDown() {
    const documentTypeFilter = () => true;
    this.documentsAllowedToUpload = this.filterDocumentTypesBy(documentTypeFilter)
  }

  filterDocumentTypesBy(filterDocumentsPredicate) {
    return this.agentdoctype.filter(filterDocumentsPredicate)
  }
  
  placeholderChange() {
    this.placeholder = "Document";
  }

  getDetails() {
    this.licenseservice.insuranceDocGet(localStorage.getItem("AgentId")).subscribe(res => {
      if (res.Documents.length <= 0 || res.Documents == undefined) {
        this.licenseData = [];
        this.ispaginationFlag = false;
        this.dataSource = null;
        this.message = "No documents found";
      } else {
        this.message = '';
        this.data = true;
        this.licenseData = res.Documents;
        for(let i=0; i< this.licenseData.length; i++) {
          if (this.licenseData[i].DocumentStatus === "Approved") {
            this.docStatus = true;
          } else {
            this.docStatus = false;
          }
        }

        // this.docStatus = true;
        this.dataSource = new MatTableDataSource(this.licenseData);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.length = this.licenseData.length;
        if (this.length < 10) {
          this.ispaginationFlag = false;
        } else {
          this.ispaginationFlag = true;
        }
        if (this.paginator.pageIndex > 0 && (this.length % 10 == 0)) {
          this.paginator.pageIndex = this.paginator.pageIndex - 1;
        }
        this.dataSource.paginator = this.paginator;
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = 'Items per page';
        paginatorIntl.nextPageLabel = 'Next page';
        paginatorIntl.previousPageLabel = 'Previous page';
        paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
          length = this.length;
          if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          // If the start index exceeds the list length, do not try and fix the end index to the end.
          const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
          const round = Math.ceil(length / 10)
          return `${(startIndex / 10) + 1}  of ${round}`;
        }
        this.dataSource.paginator._intl = paginatorIntl;
      }
    }, error => {
      this.errorMessage = "All License documents: " + error;
      this.errorEnable = true;
    });
  }

  getColor(expirationDate) {
    let todayDate = new Date()
    let currentDate = new Date().setHours(0, 0, 0, 0);
    var targetDate = new Date();
    let futureDate = targetDate.setDate(todayDate.getDate() + 30);
    let future = new Date(futureDate).setHours(0, 0, 0, 0);
    let expDate = new Date(expirationDate).setHours(0, 0, 0, 0);
    if (expDate < currentDate) {
      return "red";
    } else if (expDate > future) {
      return "black";
    } else {
      return "blue";
    }
  }

  convertDateFormat(date) {
    if (date !== '' && date !== null && date !== undefined) {
      return moment(date).format('YYYY/MM/DD');
    } else {
      return '';
    }
  }

  clear(data, type?) {
    data.DocumentCategory = this.docCategory;
    let dialogRef = this.dialog.open(InsuranceDocsClearDialogComponent, {
      width: '400px',
      height: '200px',
      data: { 'data': data, 'type': 'license' }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialog(name, type, id?): void {
    let code = null;
    code = this.agentdoctype.find(doc => doc.DocumentTypeName === name).DocumentTypeCode;
    var new_Data = {
      MasterVendorId: localStorage.getItem('AgentId'),
      DocumentTypeName: name,
      VendorLicenseId: id,
      DocumentTypeCode: code,
      DocumentCategory: this.docCategory
    };
    var Data;
    if (this.licenseData.length > 0) {
      for (let i = 0; i < this.licenseData.length; i++) {
        if (this.licenseData[i].VendorLicenseId === id) {
          Data = this.licenseData[i]
        }
      }
    }
    let dialogRef = this.dialog.open(LicenseDialogueComponent, {
      width: '650px',
      height: '470px',
      data: { data: type === 'update' ? Data : new_Data, type: type, category: this.docCategory }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.doctype = null;
      this.placeholder = "Select a Document";
    });
  }

  doctypechange(doc) {
    this.openDialog(doc, 'create');
  }

  validateDoc(name, type, id?): void {
    let code = null;
    code = this.agentdoctype.find(doc => doc.DocumentTypeName === name).DocumentTypeCode;
    var new_Data = {
      MasterVendorId: localStorage.getItem('AgentId'),
      DocumentTypeName: name,
      VendorLicenseId: id,
      DocumentTypeCode: code,
      DocumentCategory: this.docCategory
    };
    var Data;
    if (this.licenseData.length > 0) {
      for (let i = 0; i < this.licenseData.length; i++) {
        if (this.licenseData[i].VendorLicenseId === id) {
          Data = this.licenseData[i]
        }
      }
    }
      this.clientHidden = false;
      let dialogRef = this.dialog.open(PendingApprovalDialogComponent, {
        disableClose: true,
        height: '300px',
        width: '600px',
        data: { data: type === 'update' ? Data : new_Data, type: type, category: this.docCategory, pagename: 'license' }
      });
      dialogRef.afterClosed().subscribe(result => {

      });
  }

  fileEdit(docName, id, docDetails) {
    localStorage.setItem('old', JSON.stringify(docDetails));
    if (docDetails.DocumentStatus === "Pending Approval"  && (this.role === "PC Site Admin" || this.role === "PC PAR Admin" || this.role === "PC PAR Vendor Relations")) {
      this.validateDoc(docName, 'update', id);
    } else {
      this.openDialog(docName, 'update', id);
    }
  }

  doApproveReject(docName, id, docDetails) {
    let type = 'update';
    let code = null;
    code = this.agentdoctype.find(doc => doc.DocumentTypeName === docName).DocumentTypeCode;
    var new_Data = {
      MasterVendorId: localStorage.getItem('AgentId'),
      DocumentTypeName: name,
      VendorLicenseId: id,
      DocumentTypeCode: code,
      DocumentCategory: this.docCategory
    };
    var Data;
    if (this.licenseData.length > 0) {
      for (let i = 0; i < this.licenseData.length; i++) {
        if (this.licenseData[i].VendorLicenseId === id) {
          Data = this.licenseData[i];
        }
      }
    }
    let dialogRef = this.dialog.open(ApproveRejectDialogComponent, {
      disableClose: true,
      height: '300px',
      width: '600px',
      data: { data: type === 'update' ? Data : new_Data, type: type, category: this.docCategory,pagename: 'license'}
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  // Get the status color
  getStatusColor(status, updatedBy) {
    let response = this.getDocStatusColor.getStatusColor(status, updatedBy);
    this.approve_reject_button = response['Approve/Reject Button'];
    return response.CSS;
  }

  // Greyout the row if the ststus is in inprogress
  disableRow(status, updatedBy) {
    let response = this.disabletheRow.disableRow(status, updatedBy);
    this.grey = response['Disable'];
    this.disable_edit = response['Disable_Edit'];
    return response.CSS;
  }
}

export interface UserData {
  DocumentTypeName: String;
  FileName: String;
  ExpirationDate: Date;
  UploadedTimeStamp: Date;
  DocumentStatus: String;
  FileEdit: any
}



// WEBPACK FOOTER //
// ./src/app/components/agent-license/agent-license.component.ts